
import get from 'lodash/get';
import { formatDate } from 'spark-util/dateUtils';
import { transform } from 'spark-util/fpUtils';

const SET_GAP_PACKET_LIST = 'GAP_PACKET.SET_GAP_PACKET_LIST';
const SET_RECIPIENT_GAP_PACKET_LIST = 'GAP_PACKET.SET_RECIPIENT_GAP_PACKET_LIST'

//Redux actions 
export const setGapPacketList = (response) => ({ type: SET_GAP_PACKET_LIST, response });
export const setRecipientGapPacketList = (response) => ({ type: SET_RECIPIENT_GAP_PACKET_LIST, response }); 

//Redux state exposure
export const getGapPacketById = (state, id) =>get(state, `gapPacket.gapPacketList[${id}]`);
export const getRecipientGapPacketById = (state, id) =>get(state, `gapPacket.recipientGapPacketList[${id}]`);






// Initial component state
const initialState = {
	gapPacketList: [],
	recipientGapPacketList: []
};



export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_GAP_PACKET_LIST: {
			return {
				...state,
				gapPacketList: get(action.response, 'data.content', []).map(formatGapPacketDates)
		
			};
		}
		case SET_RECIPIENT_GAP_PACKET_LIST: {
			return {
				...state,
				recipientGapPacketList: get(action.response, 'data.content', []).map(formatRecipientGapPacketDates)
		
			};
		}
		default:
			return state;
	}
};

const formatGapPacketDates = transform({
	distributedDate: formatDate,
    ackDt: formatDate,
});
const formatRecipientGapPacketDates = transform({
	createdDate: formatDate,
	distributedDt: formatDate,
});
